import { useCallback } from "react";
import { getCurrentPlant } from "../../util/ApiOptionsHelper";
import { getColumnsWithGroup } from "../../api/Windows";
import { useLocation } from "react-router";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetLongDescriptionMetaData() {
  const isRequester = useLocation().pathname.includes("requester");
  const setMetadata = useWorkOrderStore(
    (state) => state.setWoDescriptionMetaData
  );

  const getLongDescriptionMetaData = useCallback(
    async (woNumber: string) => {
      const data = {
        IncludeValidValues: false,
        IncludeValidValuesExceptions: [],
        IsReadOnly: true,
        ValidValueFilters: [],
        WindowName: isRequester
          ? "mob_requester_wo_nb_comments"
          : "mob_wo_nb_comments",
        ContextPKey: {
          Plant: await getCurrentPlant(),
          WoBase: "",
          WoTask: "  ",
          WoSubtask: "  ",
        },
      };
      const response = await getColumnsWithGroup(data);
      if (!response.isError) setMetadata(woNumber, response.data);
      return response;
    },
    [isRequester, setMetadata]
  );

  return { getLongDescriptionMetaData };
}
